import CityPageTemplate from "../city-template/CityPageTemplate";
import { shivelyConfig } from "./data";

export default function ShivelyPage() {
  return <CityPageTemplate config={shivelyConfig} />;
}